import { render, staticRenderFns } from "./inputSimple.component.vue?vue&type=template&id=66497226&scoped=true&"
import script from "./inputSimple.component.vue?vue&type=script&lang=js&"
export * from "./inputSimple.component.vue?vue&type=script&lang=js&"
import style0 from "./inputSimple.component.vue?vue&type=style&index=0&id=66497226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66497226",
  null
  
)

export default component.exports